import React from 'react';
import { makeClassName } from '@siteless/util';
import { IconPropsType } from '../util/types';

const HandRightIcon = ({ className, ...rest }: IconPropsType) => (
  <svg
    className={makeClassName('HandRightIcon', className)}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    {...rest}
  >
    <path
      d="M10.92,23.49c4.18,0,7.44-2.12,9.97-6.47l1.25-2.68c0.6-1.28,0.04-2.81-1.24-3.41c-0.95-0.45-2.01-0.29-2.75,0.3v-5.8
	c0-1.42-1.15-2.57-2.57-2.57c-0.2,0-0.39,0.02-0.57,0.06V2.82c0-1.42-1.15-2.57-2.57-2.57c-1.06,0-1.98,0.65-2.37,1.57
	C9.82,1.75,9.56,1.7,9.29,1.7c-1.42,0-2.57,1.15-2.57,2.57v0.19C6.54,4.42,6.35,4.4,6.15,4.4c-1.42,0-2.57,1.15-2.57,2.57v10.38
	C3.59,20.74,6.87,23.49,10.92,23.49z M19.76,12.67c0.08,0,0.16,0.02,0.24,0.05c0.34,0.16,0.46,0.5,0.33,0.78l-1.21,2.6
	c-2.1,3.6-4.79,5.39-8.2,5.39c-2.94,0-5.33-1.86-5.33-4.15V6.96c0-0.31,0.26-0.57,0.57-0.57s0.57,0.26,0.57,0.57v4.23
	c0,0.55,0.45,1,1,1s1-0.45,1-1V4.27c0-0.31,0.26-0.57,0.57-0.57s0.57,0.26,0.57,0.57v6.92c0,0.55,0.45,1,1,1c0.55,0,1-0.45,1-1V2.82
	c0-0.31,0.26-0.57,0.57-0.57S13,2.51,13,2.82v8.37c0,0.55,0.45,1,1,1s1-0.45,1-1V5.44c0-0.31,0.26-0.57,0.57-0.57
	s0.57,0.26,0.57,0.57v9.43c0,0.46,0.32,0.86,0.76,0.97c0.45,0.11,0.91-0.1,1.12-0.51l1.19-2.29C19.33,12.8,19.54,12.67,19.76,12.67z
	"
    />
  </svg>
);

export default HandRightIcon;
